import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
function LegalModal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-51">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-[24px] shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-52">
        <div className="flex justify-between items-center mb-6" data-id="element-53">
          <h2 className="text-2xl font-bold text-brand-purple font-serif" data-id="element-54">
            {title}
          </h2>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-brand-pink text-brand-purple flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors font-bold text-lg" aria-label="Close" data-id="element-55">
            ✕
          </button>
        </div>
        <div className="text-brand-purple/80 text-sm leading-relaxed space-y-4" data-id="element-56">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | 'refund' | 'shipping' | null>(null);
  return <>
      <footer className="bg-brand-purple text-brand-pink py-12 px-4 sm:px-6 lg:px-8 mt-20" data-id="element-57">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-58">
          <div className="flex flex-col items-center md:items-start" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/sDrTYSAVGZ39uouEyXzubx/Crumbssi_Logo-Vertical-Rose.png" alt="Crumbssi Logo" className="h-14 w-auto object-contain opacity-90 mb-4" data-id="element-60" />
            <p className="text-sm font-medium opacity-80" data-id="element-61">
              Dangerously Stuffed. Hand-Crafted.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-62">
            <div className="flex space-x-6" data-id="element-63">
              <a href="https://www.instagram.com/crumbssicookies?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Instagram" data-id="element-64">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-65">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-66" />
                </svg>
              </a>
              <a href="https://www.tiktok.com/@crumbssicookies?lang=en" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="TikTok" data-id="element-67">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-68">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" data-id="element-69" />
                </svg>
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm" data-id="element-70">
              <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-71">
                Terms of Service
              </button>
              <span className="opacity-50" data-id="element-72">|</span>
              <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-73">
                Privacy Policy
              </button>
              <span className="opacity-50" data-id="element-74">|</span>
              <button onClick={() => setActiveModal('refund')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-75">
                Refund Policy
              </button>
              <span className="opacity-50" data-id="element-76">|</span>
              <button onClick={() => setActiveModal('shipping')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-77">
                Shipping Methods
              </button>
            </div>
          </div>

          <div className="text-center md:text-right text-sm opacity-80" data-id="element-78">
            <p data-id="element-79">&copy; {new Date().getFullYear()} Crumbssi Cookies.</p>
            <p data-id="element-80">All rights reserved.</p>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-81">
        {activeModal === 'terms' && <LegalModal title="Terms of Service" onClose={() => setActiveModal(null)} data-id="element-82">
            <p data-id="element-83">
              <strong data-id="element-84">Last Updated:</strong> March 2026
            </p>
            <p data-id="element-85">
              Welcome to Crumbssi Cookies. By accessing our website and placing
              an order, you agree to the following terms and conditions.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-86">
              1. Orders & Payment
            </h3>
            <p data-id="element-87">
              All orders are subject to availability. We reserve the right to
              refuse or cancel any order at our discretion. Prices are listed in
              USD and are subject to change without notice. Payment is processed
              securely at the time of checkout.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-88">
              2. Shipping & Delivery
            </h3>
            <p data-id="element-89">
              We ship fresh cookies nationwide within the United States.
              Delivery times may vary depending on your location. Crumbssi
              Cookies is not responsible for delays caused by shipping carriers
              or weather conditions. Orders are non-refundable once shipped.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-90">
              3. Menu & Availability
            </h3>
            <p data-id="element-91">
              Our weekly menu closes every Sunday at 12:00 PM EST. Orders placed
              after the cutoff will be included in the following week's batch.
              Cookie flavors and availability may change weekly.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-92">
              4. Allergen Disclaimer
            </h3>
            <p data-id="element-93">
              Our cookies are made in a facility that handles nuts, dairy, eggs,
              wheat, and soy. While we take precautions, we cannot guarantee a
              completely allergen-free environment. Please review ingredient
              lists carefully before ordering.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-94">
              5. Refunds & Returns
            </h3>
            <p data-id="element-95">
              Due to the perishable nature of our products, all sales are final.
              If your order arrives damaged, please contact us within 24 hours
              of delivery with photos, and we will work to resolve the issue.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-96">
              6. Intellectual Property
            </h3>
            <p data-id="element-97">
              All content on this website, including logos, images, and text, is
              the property of Crumbssi Cookies and may not be reproduced without
              written permission.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-98">
              7. Contact
            </h3>
            <p data-id="element-99">
              For questions regarding these terms, please reach out to us via
              our Instagram or TikTok pages.
            </p>
          </LegalModal>}

        {activeModal === 'privacy' && <LegalModal title="Privacy Policy" onClose={() => setActiveModal(null)} data-id="element-100">
            <p data-id="element-101">
              <strong data-id="element-102">Last Updated:</strong> March 2026
            </p>
            <p data-id="element-103">
              At Crumbssi Cookies, we value your privacy. This policy explains
              how we collect, use, and protect your personal information.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-104">
              1. Information We Collect
            </h3>
            <p data-id="element-105">
              When you place an order, we collect your name, email address,
              shipping address, and payment information. We may also collect
              browsing data through cookies and analytics tools to improve your
              experience.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-106">
              2. How We Use Your Information
            </h3>
            <p data-id="element-107">
              We use your information to process and fulfill orders, communicate
              order updates and promotions, improve our website and product
              offerings, and comply with legal obligations.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-108">
              3. Data Sharing
            </h3>
            <p data-id="element-109">
              We do not sell your personal information. We may share data with
              trusted third-party services (payment processors, shipping
              carriers) solely to fulfill your order.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-110">
              4. Cookies & Tracking
            </h3>
            <p data-id="element-111">
              Our website uses cookies and similar technologies to enhance your
              browsing experience and gather analytics. You can manage cookie
              preferences through your browser settings.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-112">
              5. Data Security
            </h3>
            <p data-id="element-113">
              We implement industry-standard security measures to protect your
              personal information. However, no method of electronic
              transmission is 100% secure, and we cannot guarantee absolute
              security.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-114">
              6. Your Rights
            </h3>
            <p data-id="element-115">
              You may request access to, correction of, or deletion of your
              personal data at any time by contacting us through our social
              media channels.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-116">
              7. Changes to This Policy
            </h3>
            <p data-id="element-117">
              We may update this privacy policy from time to time. Changes will
              be posted on this page with an updated revision date.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-118">
              8. Contact
            </h3>
            <p data-id="element-119">
              For privacy-related inquiries, please reach out to us via our
              Instagram or TikTok pages.
            </p>
          </LegalModal>}

        {activeModal === 'refund' && <LegalModal title="Refund Policy" onClose={() => setActiveModal(null)} data-id="element-120">
            <h3 className="text-brand-purple font-bold text-base" data-id="element-121">
              No Return Policy – Crumbssi Cookies
            </h3>
            <p data-id="element-122">
              At Crumbssi Cookies our passion is crafting gourmet cookies that
              deliver an extraordinary tasting experience — made from the finest
              ingredients, baked with precision, and presented with care. Each
              batch is freshly prepared to order, ensuring that our customers
              receive cookies of unmatched quality, every single time.
            </p>
            <p className="font-semibold text-brand-purple" data-id="element-123">
              Due to the perishable nature of our products, all sales are final.
            </p>
            <p data-id="element-124">
              We do not accept returns or offer refunds, exchanges, or
              cancellations once an order has been confirmed. This policy helps
              us maintain our commitment to freshness, food safety, and
              excellence in every bite.
            </p>
          </LegalModal>}

        {activeModal === 'shipping' && <LegalModal title="Shipping Methods" onClose={() => setActiveModal(null)} data-id="element-125">
            <h3 className="text-brand-purple font-bold text-base" data-id="element-126">
              Shipping Policy – Crumbssi Cookies
            </h3>
            <p data-id="element-127">
              At Crumbssi Cookies we believe exceptional cookies deserve
              exceptional care — from the oven to your doorstep. Our shipping
              policy is designed to ensure your order arrives fresh, beautifully
              packaged, and on time for your most cherished moments.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-128">
              📦 Order Processing
            </h3>
            <p data-id="element-129">
              Each order is freshly baked and carefully packaged by hand. Once
              your order is placed, we will ship it to you the following
              shipping day (every Monday).
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-130">
              🚚 Shipping Methods & Timeframes
            </h3>
            <p data-id="element-131">
              We currently ship across the U.S and Puerto Rico offering the
              following shipping options.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-132">
              🕒 Delivery Schedule
            </h3>
            <p data-id="element-133">
              To preserve freshness, we ship Monday to prevent weekend transit
              delays.
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-134">
              🎁 Gifting & Special Requests
            </h3>
            <p data-id="element-135">
              Sending a gift? Include a custom note at checkout — we'll take
              care of the rest. For large orders, corporate gifting, or special
              accommodations, please email us at{' '}
              <a href="mailto:crumbssicookies@gmail.com" className="underline font-semibold text-brand-purple hover:opacity-70" data-id="element-136">
                crumbssicookies@gmail.com
              </a>
            </p>

            <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-137">
              📍 Tracking Your Order
            </h3>
            <p data-id="element-138">
              Once your cookies are on their way, you'll receive a tracking
              number via email so you can follow their journey — from our
              kitchen to your cravings.
            </p>
          </LegalModal>}
      </AnimatePresence>
    </>;
}